import { Component } from 'react';
import PropTypes from 'prop-types';
import carto from '@carto/carto.js';
import Popup from './Popup';
import {addPercentage} from '../utils/utils';

class Layer extends Component {

  static propTypes = {
    map: PropTypes.object,
    sql: PropTypes.string, 
    cartocss: PropTypes.string, 
    client: PropTypes.object,
    hidden: PropTypes.bool,
    visible: PropTypes.bool,
    options: PropTypes.object, 
    onClick: PropTypes.func,
    total: PropTypes.object,
    table: PropTypes.string
  }

  constructor(props) {
    super(props);
    const { visible, sql, cartocss, options, onClick } = this.props;
    const cartoSql = new carto.source.SQL(sql);
    const cartoCss = new carto.style.CartoCSS(cartocss);
    this.layer = new carto.layer.Layer(cartoSql, cartoCss);
    this.setVisibility(visible);
  }

  componentDidMount() {
    const { client, options } = this.props;

    client.addLayer(this.layer);
    client.getLeafletLayer().addTo(this.props.map);

    const popup = L.popup({ closeButton: true });
    this.layer.setFeatureOverColumns(options.featureOverColumns)
    this.layer.on(carto.layer.events.FEATURE_OVER, featureEvent => {
      const data = addPercentage(featureEvent.data, this.props.total);
      const dataWithTable = {
        ...data, 
        table: this.props.table
      }
      //console.log('table', dataWithTable)
      popup.setLatLng(featureEvent.latLng);
      popup.setContent(Popup(dataWithTable));
      popup.openOn(this.props.map);
    });

    this.layer.on(carto.layer.events.FEATURE_OUT, featureEvent => {
      this.props.map.closePopup();
    });

    // click on layer
    this.layer.setFeatureClickColumns(options.featureClickColumns)
    this.layer.on(carto.layer.events.FEATURE_CLICKED, featureEvent => {
        //console.log('featureEvent.data.geo_name', featureEvent.data.geo_name)
        this.props.onClick(featureEvent.data.geo_name);
    });
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.cartocss !== this.props.cartocss 
    || nextProps.visible !== this.props.visible 
    || nextProps.sql !== this.props.sql;
  }

  setVisibility = (isVisible) => {
    isVisible ? this.layer.show() : this.layer.hide();
  }
  
  render() {
    const { visible, cartocss, sql } = this.props;
    const layerStyle = this.layer.getStyle();
    const layerQuery = this.layer.getSource();
    layerQuery.setQuery(sql);
    //console.log('render in layer', visible, cartocss, layerStyle, layerQuery);
    layerStyle.setContent(cartocss).then(() => this.setVisibility(visible));
    return null;
  }
}

export default Layer;



// WEBPACK FOOTER //
// ./src/components/Layer.js